<script>
import InternationalNumberInput from 'tripod-styles/src/components/Inputs/InternationalNumberInput.svelte'
import { ShadowRoot } from './../../libraries/ShadowRoot.js';
import { StoreForm } from './StoreForm.js';
import { AppForms } from "../../libraries/AppForms";
import { turpial } from "../../libraries/turpial";
import { InjectScript } from '../../libraries/InjectScript';
import { onMount } from 'svelte';
import PixelEventsHook from "tripod-styles/src/libraries/mybuilder/PixelEventsHook";



export let changeStep;
export let Data;



let has_chooser_plan_module = Data.has_chooser_plan_module ?? false;
let userFromCampaign = Data.userFromCampaign;
let is_online = Data.is_online ?? true;
let has_captcha = typeof Data.has_captcha === "undefined" ? false : Data.has_captcha;
if(is_online === false){
    has_captcha = false;
}
export let errors;
let getMembership = ()=>{
    return tripod_register.membership;
} 

let host = "https://app.3pod.io/";
if(is_online === false){
    host = Data?.host_offline ?? "http://localhost/beta.3pod.io/"
}


let typeOfSignUp = Data.type ?? "default";
let lang = Data.lang;
let buttonSubmit = null;
let formLang = lang.forms.basic;
let form = null;


onMount(()=>{
    window.user_signed = null;
    let dataForm = $StoreForm?.dataForm;
    dataForm.login_token = null
    dataForm.login_token2 = null;
    StoreForm.update("dataForm", dataForm, $StoreForm?.dataForm);

    console.log("some fields was restarted.")
})

tripod_register.submit = function(){
    catchData(form, function(data){
        let hcaptcha = $ShadowRoot.querySelector("iframe[data-hcaptcha-response]");
        data.captcha = hcaptcha.getAttribute("data-hcaptcha-response")
        return data;
    });
}
function checkForm(data){
    let is_all_valid = true;
    data = data || {};

    // checks validation inputs.
    let phone = form.querySelector(".int-phone");
    if(phone.dataset.valid === "false"){ is_all_valid = false }


    // check empty inputs
    let checks = ["first_name", "last_name", "email", "phone"];
    checks.map(( element )=>{
        if(typeof data[element] !== "string"){
            is_all_valid = false;
        }
        if(data[element] === ""){
            console.log(data[element])
            is_all_valid = false;
        }
    });

    
    
    return is_all_valid;
}



onMount(()=>{
    if((typeOfSignUp === "trial" || typeOfSignUp === "basic") && has_captcha === true){
        InjectScript("https://js.hcaptcha.com/1/api.js", {
            attrs: {
                async: "",
                defer: "",
            },
            onload: ()=>{
                hcaptcha.render(buttonSubmit, {
                    sitekey: 'bf7e6dce-eb06-4ad7-8aa1-cddcbd4f365d',
                    'data-callback': 'captchaSubmit',
                });
            }
        })
    }
})


function sendEventToTable(dataRegister){
    if(window.location.href.search("localhost") >= 0){
        return;
    }

    

    try {
        dataRegister.user_from_campaign = tripod_register.userFromCampaign;
        dataRegister.add_trial_end = tripod_register?.add_trial_end ?? false;
        dataRegister.type_event = "Widget Registration";
        dataRegister.referrer = document.location.href;
        dataRegister.more_tags = tripod_register?.more_tags ?? "";
        
        let url;
        if(window.IS_ONLINE === false){
            url = "http://localhost/beta.3pod.io/public/api/v1/events/registerUser";
        }else{
            url = "https://app.3pod.io/public/api/v1/events/registerUser";
        }

        turpial.fetch({
            url: [url],
            method: "POST",
            type: "text",
            data: JSON.stringify({
                token: btoa(JSON.stringify(dataRegister)).split("").reverse().join(""),
            }),
            ready: (data)=>{
                new PixelEventsHook("Contact", "fbq");
                new PixelEventsHook("Lead", "fbq");
                console.log("Lead 3!");
            }
        })
    } catch (error) {
        console.log(error)
    }
}




function catchData(target, before){
    before = before||function(data){ return data; }
    errors.hide();
    let form = target;
    
    let data = AppForms.retrieve({
        targets: ".formElements",
        form: form,
    });
    if(checkForm(data) === false){ 
        AppForms.statusButton(buttonSubmit, "enabled");
        errors.showError(lang.errors.uncompleted);
        return;
    }
    data = before(data);

    data.userFromCampaign = userFromCampaign;
    data.referral_code = Data?.referral_code || null;
    let main_data = data;

    data.password_again = data.password;
    let dataForm = data;
    let encodeEmail = btoa(data.email).split("").reverse().join("")
    AppForms.statusButton(buttonSubmit, "disabled");
    

    let getPlansUrl = host+"api/getPlans";
    
    if(typeof Data?.userFromCampaign === "string"){
        getPlansUrl = `${host}api/getPlans?tag=${btoa(Data?.userFromCampaign)}`
    }

    let method = "GET"
    let connections = [
        getPlansUrl,
        host+"api/isUserRegistered/"+encodeEmail,

    ];
    if(typeOfSignUp === "trial" || typeOfSignUp === "basic"){
        method = "POST";
        connections = [
            host+"public/api/v1/registerUser"
        ];
    }
    data.affiliate = Data?.affiliate ?? null;

    sendEventToTable(data);

    turpial.fetch({
        files: connections,
        method: method,
        type: "text",
        data: JSON.stringify(data),
        ready: (data)=>{
            // on default
            switch (typeOfSignUp) {
                case "default":
                    let plans = JSON.parse(data[0]).response[getMembership()];
                    let isEmailRegistered = JSON.parse(data[1]);
                    AppForms.statusButton(buttonSubmit, "enabled");
                    console.log(isEmailRegistered)
                    if(isEmailRegistered.response === true){
                        errors.showError(lang.errors.email_registered);
                        return;
                    }
                    
                    let plans_selected = plans.filter(( plan )=>{
                        // buscar entre los seleccionados en tripod_register
                        if(typeof tripod_register.plans_selected.find(( selected )=>{
                            if(selected === plan.__id__){
                                return selected;
                            }
                        }) !== "undefined"){
                            // si se encuentran coicidencias devolver el plan
                            return plan;
                        }
                    })

                    tripod_register.plans = plans;
                    tripod_register.dataForm = dataForm;            

                    tripod_register.plansFetched = plans_selected;

                    StoreForm.update("plansFetched", plans_selected);
                    StoreForm.update("plans", plans);
                    StoreForm.update("dataForm", dataForm, $StoreForm?.dataForm);
                    if(typeof gtag !== "undefined"){
                        gtag('event', 'btn_sign_up_widget_data', {"send_to": "G-XEF7QBK3Z5"})
                    }
                    if(has_chooser_plan_module === true){
                        changeStep("ChoosePlan");
                        return;
                    }
                    changeStep("PaymentFunnels");
                break;
                case "trial":
                    data = JSON.parse(data[0]);
                    if(data.status === "error"){
                        AppForms.statusButton(buttonSubmit, "enabled");
                        errors.showError(data.message);
                        return;
                    }
                    if(data.status === "success"){
                        if(data?.response?.url_sign_in){
                            let url = data?.response?.url_sign_in;
                            if(typeof gtag !== "undefined"){
                                gtag('event', 'btn_sign_up_widget_data', {"send_to": "G-XEF7QBK3Z5"})
                                gtag('event', 'btn_sign_up_widget_trial', {"send_to": "G-XEF7QBK3Z5"})
                                gtag('event', 'btn_sign_up_widget_register', {"send_to": "G-XEF7QBK3Z5", 'tag': (Data?.userFromCampaign ?? 'N/A'), 'user': main_data?.email ?? ""})

                                let event_data = {
                                    tag: (Data?.userFromCampaign ?? 'N/A'),
                                    email: main_data?.email ?? ""
                                };

                                try {
                                    let on_register_event = window?.tripod_events?.on_register ?? null;
                                    if(typeof on_register_event === "function"){
                                        on_register_event(event_data);
                                    }
                                } catch (error) {
                                    console.error(error)
                                }
                            }
                            setTimeout(() => {
                                window.location.href = url;
                            }, 1500);
                            
                        }
                        return;
                    }
                case "basic":
                    data = JSON.parse(data[0]);
                    if(data.status === "error"){
                        AppForms.statusButton(buttonSubmit, "enabled");
                        errors.showError(data.message);
                        return;
                    }
                    if(data.status === "success"){
                        if(data?.response?.url_sign_in){
                            let url = data?.response?.url_sign_in;
                            if(typeof gtag !== "undefined"){
                                gtag('event', 'btn_sign_up_widget_data', {"send_to": "G-XEF7QBK3Z5"})
                                gtag('event', 'btn_sign_up_widget_trial', {"send_to": "G-XEF7QBK3Z5"})
                                gtag('event', 'btn_sign_up_widget_register', {"send_to": "G-XEF7QBK3Z5", 'tag': (Data?.userFromCampaign ?? 'N/A'), 'user': main_data?.email ?? ""})

                                try {
                                    let on_register_event = window?.tripod_events?.on_register ?? null;
                                    if(typeof on_register_event === "function"){
                                        on_register_event();
                                    }
                                } catch (error) {
                                    console.error(error)
                                }
                            }
                            setTimeout(() => {
                                window.location.href = url;
                            }, 1500);
                        }
                        return;
                    }
                break;
                default:
                    break;
            }
            
        },
        onerror: (data)=>{
            console.log.error(data)
            AppForms.statusButton(buttonSubmit, "enabled");
        }
    });
}
let pattern = ".{6,}"
</script>
<header>
    <h2 class="has-text-black fw700 font-size-24 title-first-step">
        {lang.title}
    </h2>
    {#if !has_chooser_plan_module}
        <p class="has-text-dark f400 font-size-16 subtitle-first-step">
            {@html lang.subtitle}
        </p>
    {/if}
    {#if has_chooser_plan_module}
        <h2 class="font-size-24 has-text-black fw700">
            Paso 1 de 3
        </h2>
    {/if}               
</header>
<main>
    <form class="columns is-multiline" action="" onsubmit="event.preventDefault()" method="POST" bind:this="{form}" on:submit|preventDefault="{(e)=>{ catchData(e.target) }}">
        <div class="field field-input column is-12">
            <div class="control has-text-left">
                <label for="" class="fw600 label-text">{formLang.name}</label>
                <input type="text" value="{$StoreForm?.dataForm["first_name"] ?? ""}" name="first_name" placeholder="{formLang.name}" class="input formElements is-fullwidth" minlength="2" required>
            </div>
        </div>
        <div class="field field-input column is-12">
            <div class="control has-text-left">
                <label for="" class="fw600 label-text">{formLang.lastname}</label>
                <input type="text" name="last_name" value="{$StoreForm?.dataForm["last_name"] ?? ""}" placeholder="{formLang.lastname}" class="input formElements is-fullwidth" minlength="2" required>
            </div>
        </div>
        <div class="field field-input column is-12">
            <div class="control has-text-left">
                <label for="" class="fw600 label-text">{formLang.email}</label>
                <input type="email" name="email" value="{$StoreForm?.dataForm["email"] ?? ""}" placeholder="E-mail" class="input formElements  is-fullwidth" minlength="4" required>
            </div>
        </div>
        <div class="field field-input field-payment-funnels column is-12 intl-phone-container">
            <div class="control has-text-left">
                <label for="" class="fw600 label-text">{lang.forms.planSelection.phone}</label>
                <InternationalNumberInput 
                    names={{
                        dial: "dial",
                        phone: "phone",
                        country: "code_country",
                    }}
                    selected_code={$StoreForm.dataForm?.code||"CO"}
                    selected_dial={$StoreForm.dataForm?.dial||"+57"}
                    selected_country={$StoreForm.dataForm?.country||"Colombia"}
                    selected_value={$StoreForm.dataForm?.phone||""}
                    ClassInputs="formElements int-phone" />
            </div>
        </div>
        <div class="field field-input column is-12">
            <div class="control has-text-left">
                <label for="" class="fw600 label-text">{lang.forms.basic.password}</label>
                <input pattern={pattern} title="{formLang.errors.password_error}" type="password" value="{$StoreForm?.dataForm["password"] ?? ""}" name="password" placeholder="{lang.forms.basic.password}" class="input formElements is-fullwidth" required>
            </div>
        </div>
        <div class="field field-input column is-12">
            <div class="buttons is-grouped is-centered">
                {#if ((typeOfSignUp === "trial" || typeOfSignUp === "basic") && has_captcha === true)}
                        <button bind:this={buttonSubmit} data-callback="captchaSubmit" type="submit" data-size="invisible" class="button  is-success has-text-white">
                            {formLang.button}
                        </button>
                    {:else}
                        <button bind:this={buttonSubmit} type="submit" class="button is-primary is-fullwidth">
                            {formLang.button}
                        </button>
                {/if}
                
            </div>
        </div>
        {#if (formLang?.sign_in?.active ?? true) === true && typeOfSignUp === "basic"}
            <div class="field field-input column is-12">
                <p class="require-fields">
                    {@html formLang.sign_in.already_has} <span class="fw600 has-text-dark has-text-left">
                        <a href="{host}user/login" class="has-text-dark is-underlined">
                            {@html formLang.sign_in.in}
                        </a>
                    </span>
                </p>
            </div>
        {/if}   
        {#if (formLang?.sign_in?.active ?? false) === true && typeOfSignUp === "default"}
            <div class="field field-input column is-12">
                <p class="require-fields">
                    {@html formLang.sign_in.already_has} <span class="fw600 has-text-dark has-text-left">
                        <a href="#/" on:click="{()=>{ changeStep("SignInForm") }}" class="has-text-dark is-underlined">
                            {@html formLang.sign_in.in}
                        </a>
                    </span>
                </p>
            </div>
        {/if}
        <div class="field field-input field-payment-agreement column is-12">
            <div class="pb-alt-1">
                <hr class="my-0">
            </div>
            <p class="has-text-left font-restricted-size-14 fw400 agree-terms-3pod">
                {#each (lang?.forms?.guarantee ?? []) as item}
                    {@html item}
                {/each}
            </p>
        </div>
    </form>
</main>
<style>
form{
    position: relative;
    padding: 1.75rem 2.25rem;
}
@media only screen and (max-width:768px){
    form{
        padding: 1.75rem 0rem;
    }
}
form .field{
    padding: 0.5rem 0.45rem;
}
form .field .control{
    text-align: left;
}
</style>